var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"clipped-text",attrs:{"title":_vm.hoverTitle,"aria-label":_vm.hoverTitle}},[_vm._v(_vm._s(_vm.displayText))])}
var staticRenderFns = []

export { render, staticRenderFns }